if (!window.Eurus.loadedScript.includes('pagination.js')) {
  window.Eurus.loadedScript.push('pagination.js');

  const isTargetCollection = () => window.location.pathname.includes('/collections/alle-producten');
  let observer;
  let scheduled = false;

  const decodeAttribute = (value) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value || '';
    return textarea.value;
  };

  const readLabelData = (item) => {
    const dataElement = item.querySelector('[x-labels-data]');
    if (!dataElement) return {};

    const rawValue = dataElement.getAttribute('x-labels-data') || '';
    const candidates = [rawValue, decodeAttribute(rawValue)];

    for (const candidate of candidates) {
      try {
        return JSON.parse(candidate);
      } catch (error) {
        // Try the next representation.
      }
    }

    return {};
  };

  const hasSoldOutLabel = (item) => {
    const text = (item.textContent || '').toLowerCase();
    return text.includes('niet op voorraad') || text.includes('uitverkocht') || text.includes('sold out');
  };

  const isUnavailable = (item) => {
    const data = readLabelData(item);
    const available = data.available;
    const quantity = Number(data.qty);
    const inventoryManaged = Boolean(data.inventory_management);
    const preorder = data.can_show_preorder === true || data.can_show_preorder === 'true';

    if (available === false || available === 'false') return true;
    if (item.querySelector('button[name="add"][disabled]')) return true;
    if (hasSoldOutLabel(item)) return true;

    return inventoryManaged && Number.isFinite(quantity) && quantity <= 0 && !preorder && available !== true && available !== 'true';
  };

  const reorderGrid = () => {
    if (!isTargetCollection()) return;

    const grid = document.getElementById('items-grid');
    if (!grid) return;

    const productItems = Array.from(grid.children).filter((item) => item.classList.contains('grid-item'));
    if (!productItems.length) return;

    productItems.forEach((item) => {
      item.dataset.bbUnavailable = isUnavailable(item) ? 'true' : 'false';
    });

    let seenUnavailable = false;
    const needsReorder = productItems.some((item) => {
      if (item.dataset.bbUnavailable === 'true') {
        seenUnavailable = true;
        return false;
      }
      return seenUnavailable;
    });

    if (!needsReorder) return;

    const availableItems = productItems.filter((item) => item.dataset.bbUnavailable !== 'true');
    const unavailableItems = productItems.filter((item) => item.dataset.bbUnavailable === 'true');
    const fragment = document.createDocumentFragment();

    availableItems.forEach((item) => fragment.appendChild(item));
    unavailableItems.forEach((item) => fragment.appendChild(item));
    grid.appendChild(fragment);
  };

  const scheduleReorder = () => {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      reorderGrid();
    });
  };

  const observeGrid = () => {
    if (!isTargetCollection()) return;

    const root = document.getElementById('ProductGridContainer');
    if (!root) return;

    if (observer) observer.disconnect();
    observer = new MutationObserver(scheduleReorder);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    scheduleReorder();
  };

  document.addEventListener('DOMContentLoaded', observeGrid);
  document.addEventListener('eurus:collection:reloaded', observeGrid);
  document.addEventListener('shopify:section:load', observeGrid);

  if (document.readyState !== 'loading') {
    observeGrid();
  }

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xPagination', (sectionId) => ({
        loading: false,
        loadData(url) {
          this.loading = true;

          fetch(url)
            .then((response) => response.text())
            .then((response) => {
              const parser = new DOMParser();
              const html = parser.parseFromString(response, 'text/html');
              const productGrid = html.getElementById('items-grid');
              const newProducts = productGrid
                ? Array.from(productGrid.children).filter((item) => item.classList.contains('grid-item'))
                : [];

              let productsOnPage = document.getElementById('items-grid');
              const blogGrid = document.getElementById('blog-grid');
              if (blogGrid) productsOnPage = blogGrid;
              if (!productsOnPage) return;

              newProducts.forEach((product, index) => {
                setTimeout(() => {
                  productsOnPage.insertAdjacentHTML('beforeend', product.outerHTML);
                  scheduleReorder();

                  if (index === newProducts.length - 1) {
                    document.dispatchEvent(new CustomEvent('eurus:collection:reloaded'));
                  }
                }, index * 300);
              });

              this._renderButton(html);
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
            });
        },
        _renderButton(html) {
          const destination = document.getElementById(`btn-pagination-${sectionId}`);
          const source = html.getElementById(`btn-pagination-${sectionId}`);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}
